import { types, actions } from './requests'
export const MERGEMOLD_TYPES = {
    ...types('MERGEMOLD'),
}
export const MERGEMOLD_ACTIONS = {
    ...actions('MERGEMOLD'),
}